import { CalendarPlus, X } from 'lucide-react'

interface DatasAbonadasFieldProps {
  datas: string[]
  onChange: (datas: string[]) => void
}

/** Campo com uma ou mais datas a serem abonadas. */
function DatasAbonadasField({ datas, onChange }: DatasAbonadasFieldProps) {
  const atualizar = (idx: number, valor: string) => {
    onChange(datas.map((d, i) => (i === idx ? valor : d)))
  }
  const remover = (idx: number) => {
    onChange(datas.filter((_, i) => i !== idx))
  }

  return (
    <div className="sm:col-span-2">
      <label className="block text-[13px] font-medium text-[#374151] mb-1.5">
        {datas.length > 1 ? 'Datas a serem Abonadas' : 'Data a ser Abonada'}
      </label>
      <div className="flex flex-col gap-2">
        {datas.map((d, idx) => (
          <div key={idx} className="flex items-center gap-2">
            <input
              type="date"
              value={d}
              onChange={e => atualizar(idx, e.target.value)}
              className="flex-1 px-3 py-2.5 rounded-lg border border-[#D1D5DB] text-[14px] focus:outline-none focus:ring-2 focus:ring-[#1E4FBF]/20 focus:border-[#1E4FBF]"
            />
            {datas.length > 1 && (
              <button
                type="button"
                onClick={() => remover(idx)}
                title="Remover data"
                className="w-10 h-10 rounded-lg border border-[#E7E9EC] text-[#9CA3AF] hover:text-[#B91C1C] hover:bg-[#FEF2F2] flex items-center justify-center shrink-0"
              >
                <X className="w-4 h-4" strokeWidth={1.9} />
              </button>
            )}
          </div>
        ))}
      </div>
      <button
        type="button"
        onClick={() => onChange([...datas, ''])}
        className="mt-2 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[12.5px] font-medium text-[#1E4FBF] bg-[#EEF3FE] hover:bg-[#DCE6FC] transition-colors"
      >
        <CalendarPlus className="w-3.5 h-3.5" strokeWidth={1.9} />
        Adicionar outra data
      </button>
    </div>
  )
}

export default DatasAbonadasField
